export default __webpack_public_path__ + "static/spacer_bottle_bg-6ee24645fde1c8dc2ef6e5467d6fae4d.jpg";